export default "__VITE_ASSET__B7A$CJat__"